import { useState, useEffect } from 'react'
import { toast } from 'react-toastify';

export const useFetchAllParametrosSistema = ({marvarApi, dispatch, onLogout}) => {

    // 1. Para los datos recuperados de la BD
    const [ dataParametrosSistema, setDataParametrosSistema ] = useState([])
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchAllParametrosSistema, setLoadingFetchAllParametrosSistema ] = useState(false)

    // 3. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {            
            const response = await marvarApi.get(`/environments/fetch-all-environments`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchAllParametrosSistema(true)
        fetchData()
            .then((resp) => {
                setDataParametrosSistema(resp.rows)
                setLoadingFetchAllParametrosSistema(false)
            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchAllParametrosSistema(false)
            })
    }, [execute])

    return {  dataParametrosSistema, loadingFetchAllParametrosSistema, executeFetch }

}

export const useFetchSpecificParametroSistema = ({marvarApi, dispatch, onLogout, Forms}) => {

    // 1. Para los datos recuperados de la BD
    // const [infoClient, setInfoClient] = useState([])
    const { FormScreen } = Forms
    const { formState, setFormState } = FormScreen
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchSpecificParametroSistema, setLoadingFetchSpecificParametroSistema ] = useState(false)

    // 3. Para setear parametros de búsqueda al fetch
    const [paramsToSearch, setParamsToSearch] = useState({idenvironment: ''})

    // 4. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            
            const response = await marvarApi.get(`/environments/fetch-specific-environment/${paramsToSearch.idenvironment}`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(paramsToSearch.idenvironment > 0 ){
            setLoadingFetchSpecificParametroSistema(true)
            fetchData()
                .then((resp) => {
                    
                    // Setea en el estado del formulario los datos del registro
                    const { rows } = resp
                    setFormState((prevState) => ({
                        ...prevState,
                        idenvironment: rows[0].idenvironment || '',
                        clave: rows[0].clave || '',
                        valor: rows[0].valor ?? '',
                        editable: Number(rows[0].editable),
                        estado: Number(rows[0].estado)
                    }))
                    setLoadingFetchSpecificParametroSistema(false)

                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchSpecificParametroSistema(false)
                })
        }
    }, [execute])

    return { loadingFetchSpecificParametroSistema, setParamsToSearch, executeFetch }

}